import { Operation } from "@apollo/client";
import { showAlert } from "@design-system";
import { FC, useEffect, useRef } from "react";
import { NetworkStatusAction } from "react-apollo-network-status";

type VPDNetworkStatusAction = Omit<NetworkStatusAction, "payload"> & {
  payload: {
    operation: Operation | undefined;
  };
};

type Props = {
  useApolloNetworkStatusReducer: <T>(
    reducer: (state: T, action: VPDNetworkStatusAction) => T,
    initialState: T
  ) => T;
};

// Accumulate every dispatched action into a queue so rapid successive actions
// (e.g. updatePhase SUCCESS batched with the next REQUEST before React renders)
// are never silently dropped.
type QueueState = {
  queue: VPDNetworkStatusAction[];
  seq: number;
};

const initialState: QueueState = { queue: [], seq: 0 };

const networkStatusReducer = (state: QueueState, action: VPDNetworkStatusAction): QueueState => {
  return { queue: [...state.queue, action], seq: state.seq + 1 };
};

export const CrudUserFeedbackContainer: FC<Props> = ({ useApolloNetworkStatusReducer }) => {
  const state = useApolloNetworkStatusReducer(networkStatusReducer, initialState);
  const lastProcessedSeq = useRef(0);

  useEffect(() => {
    // Process only actions appended since the last render
    const unprocessedCount = state.seq - lastProcessedSeq.current;
    const newActions = state.queue.slice(state.queue.length - unprocessedCount);
    lastProcessedSeq.current = state.seq;
    newActions.forEach(showAlert);
  }, [state]);

  return null;
};
